import React from "react";
import ResourceManager from "../../components/admin/ResourceManager";
import { resolveMediaUrl } from "../../lib/mediaUrl";

const BLOG_FIELDS = [
    { key: "title",     label: "Title",            type: "text", required: true, placeholder: "5 Signs Your Brand Needs a Redesign" },
    { key: "date",      label: "Display Date",     type: "text", required: true, placeholder: "April 2025" },
    { key: "date_iso",  label: "ISO Date",         type: "text", placeholder: "2025-04-12", helpText: "Used for HTML <time> tag (YYYY-MM-DD)." },
    { key: "category",  label: "Category",         type: "text", required: true, placeholder: "Branding, Signage, Logo Design…" },
    { key: "excerpt",   label: "Excerpt",          type: "textarea", required: true, rows: 3 },
    { key: "image_url", label: "Cover Image",      type: "image", required: true, helpText: "Upload a cover image or paste a public URL." },
    { key: "read_time", label: "Read time",        type: "text", placeholder: "5 min read" },
    { key: "position",  label: "Position",         type: "number" },
    { key: "visible",   label: "Visibility",       type: "switch", defaultValue: true },
];

export const AdminBlogPage = () => (
    <ResourceManager
        resourceKey="blog"
        title="Blog Manager"
        singular="Blog Post"
        description="Add, edit and remove posts that appear on the public Blog page."
        endpoint="/admin/blog"
        fields={BLOG_FIELDS}
        renderItem={(item) => (
            <div className="flex items-center gap-4">
                <img
                    src={resolveMediaUrl(item.image_url)}
                    alt={item.title}
                    className="w-20 h-20 object-cover rounded-lg border border-white/5 flex-shrink-0 bg-[#0a0a0a]"
                    loading="lazy"
                />
                <div className="min-w-0">
                    <div className="font-inter text-[10px] uppercase tracking-[0.25em] text-gold mb-1">
                        {item.category} · {item.date}
                    </div>
                    <div className="font-poppins font-medium text-white truncate">{item.title}</div>
                    <p className="mt-1 font-inter text-xs text-zinc-500 line-clamp-2">{item.excerpt}</p>
                </div>
            </div>
        )}
    />
);

export default AdminBlogPage;
